/* eslint-disable prefer-const */
import RequestManager from './RequestManager';

import AAF from '../AAF/AAF'
import ApaMetadataTask from './tasks/application/ApaMetadataTask';
import ApaMetadataMiddlewareTask from './tasks/application/ApaMetadataMiddlewareTask';
import ApaAssetTask from './tasks/application/ApaAssetTask';
import ApaLegalsTask from './tasks/application/ApaLegalsTask';
import ApaLauncherTask from './tasks/application/ApaLauncherTask';
import BadgesTask from './tasks/application/BadgesTask';
import NavDataTask from './tasks/application/NavDataTask';
import ContentDataTask from './tasks/content/ContentDataTask';
import ContentSerieTask from './tasks/content/ContentSerieTask';
import GetBookmarkTask from './tasks/user/GetBookmarkTask';
import ContentRecommendationsTask from './tasks/content/ContentRecommendationsTask';
import PurchaseButtonInfoTask from './tasks/payway/PurchaseButtonInfoTask';
import PurchaseButtonInfov585Task from './tasks/payway/PurchaseButtonInfov585Task';
import PlayerGetMediaTask from './tasks/player/PlayerGetMediaTask';
import VerticalLookUp from './tasks/search/VerticalLookUpTask';
import Vertical from './tasks/search/VerticalTask';
import DeviceAttachTask from './tasks/device/AttachTask';
import StartHeaderInfoTask from './tasks/user/StartHeaderInfoTask';
import IsLoggedInTask from './tasks/user/IsLoggedInTask';
import PushSessionTask from './tasks/user/PushSessionTask';
import UserFavoriteTask from './tasks/user/UserFavoriteTask';
import LinealChannelsTask from './tasks/payway/LinealChannelsTask';
import SmartCardLoginTask from './tasks/user/SmartCardLoginTask';
import authdeviceTask from './tasks/user/authdeviceTask';
import authdeviceV1Task from './tasks/user/authDeviceV1Task';
import ActivateControlPinTask from './tasks/user/ActivateControlPinTask';
import ActivateControlPinWithoutEmailTask from './tasks/user/ActivateControlPinWithoutEmailTask';
import ChangeControlPinTask from './tasks/user/ChangeControlPinTask';
import ModifyControlPinTask from './tasks/user/ModifyControlPinTask';
import UserSeenLastTask from './tasks/user/UserSeenLastTask';
import CheckControlPinTask from './tasks/user/CheckControlPinTask';
import RemindControlPinTask from './tasks/user/RemindControlPinTask';
import RegisterTask from './tasks/user/RegisterTask';
import LoginTask from './tasks/user/LoginTask';
import LoginDynaminTask from './tasks/music/LoginDynamic';
import MusicTask from './tasks/music/MusicTask';
import Login360Task from './tasks/user/Login360Task';
import LoginNETTask from './tasks/user/LoginNETTask';
import LoginCMByEmailTask from './tasks/music/LoginCMByEmailTask';
import LoginCMByPhoneTask from './tasks/music/LoginCMByPhoneTask';
import LoginByTokenTask from './tasks/user/LoginByTokenTask';
import QueryUserSyncTask from './tasks/user/QueryUserSyncTask';
import RefreshTokenTask from './tasks/user/RefreshTokenTask';
import CpfQueryTask from './tasks/user/CpfQueryTask';
import SendPasswordReminderTaks from './tasks/user/SendPasswordReminderTaks';
import SetTermsAndConditionsTask from './tasks/user/SetTermsAndConditionsTask';
import WorkflowTask from './tasks/payway/WorkFlowStartTask';
import ConfirmTask from './tasks/payway/ConfirmTask';
import ChangePaymentInfoTask from './tasks/payway/ChangePaymentInfoTask';
import AppVersionTask from './tasks/application/AppVersionTask';
import EpgVersionTask from './tasks/application/EpgVersionTask';
import AvatarsTask from './tasks/user/profile/AvatarsTask';
import CreateProfileTask from './tasks/user/profile/CreateProfileTask';
import DeleteProfileTask from './tasks/user/profile/DeleteProfileTask';
import ReadProfileTask from './tasks/user/profile/ReadProfileTask';
import UpdateProfileTask from './tasks/user/profile/UpdateProfileTask';
// Task para Action Bar
import AddFavoriteTask from './tasks/user/AddFavoriteTask';
import DeleteFavoriteTask from './tasks/user/DeleteFavoriteTask';
import AddBlockedChannelsTask from './tasks/user/AddBlockedChannelsTask';
import DeleteBlockedChannelsTask from './tasks/user/DeleteBlockedChannelsTask';
import CheckBlockedChannelsTask from './tasks/user/CheckBlockedChannelsTask';
import ReminderCreateTask from './tasks/user/ReminderCreateTask';
import ReminderDeleteTask from './tasks/user/ReminderDeleteTask';
import ReminderListTask from './tasks/user/ReminderListTask';
import getAppConfig from '../config/appConfig';
import storage from '../components/DeviceStorage/DeviceStorage';
import store from '../store';
import { Dates } from '../packages/dates';
import Device from '../devices/device';
import env from '../devices/all/env';
import { receiveIsLoggedIn, receiveUserToken, setLastTouchSeen } from '../reducers/user';
import { youboraLauncher } from '../config/youboraLoader';
import Utils, { authdeviceInterceptor, setYouboraData } from '../utils/Utils';
import PureEpgTask from './tasks/epg/PureEpgTask';
import FiltersTask from './tasks/epg/FiltersTask';
import LevelRibbonTask from './tasks/cms/LevelRibbonTask';
import RemoveLiveChannelTask from './tasks/cms/RemoveLiveChannelTask';
import LevelGenericTask from './tasks/cms/LevelGeneric';
import SimpleGetRequestTask from './tasks/SimpleGetRequestTask'
import EpgPersistence from '../AAF/Nepg/EpgPersistence';
import settings from '../devices/all/settings';

import AlbumDetailTask from './tasks/music/AlbumDetailTask';
import PlaylistDetailTask from './tasks/music/PlaylistDetailTask';
import SimpleCMMTask from './tasks/music/SimpleCMMTask';
import ArtistDetailTask from './tasks/music/ArtistDetailTask';
import ArtistAlbumsTask from './tasks/music/ArtistAlbumsTask';
import ArtistSimilarTask from './tasks/music/ArtistSimilarTask';
import ToggleFollowTask from './tasks/music/ToggleFollowTask';
import ArtistRadiosLiveTask from './tasks/music/ArtistRadiosLiveTask';
import GenreRadiosTask from './tasks/music/GenreRadiosTask';

import GetUserInfoTask from './tasks/user/GetUserInfoTask';
import ModifyUserTask from './tasks/user/ModifyUserTask';
import PinStatusWithTimerValidationTask from './tasks/user/PinStatusWithTimerValidationTask';
import RemoveLastSeenTask from "./tasks/cms/RemoveLastSeenTask";
import RemoveRecordingsTask from "./tasks/cms/RemoveRecordingsTask";
import UserSuspendedTask from "./tasks/payway/UserSuspendedTask";

import MultiPurchaseButtonInfo from './tasks/search/MultiPurchaseButtonInfo';
import { Resilence } from 'src/AAF/Resilence/main';
import {checkAccountStatus} from 'src/AAF/Auth/login';
import { STATUS_ACCOUNT_SUSPENDED} from 'src/AAF/Auth/authConstants';
import MultiContentSearchTask from './tasks/search/MultiContentSearchTask';
import IptvPaymentMethodsTask from './tasks/payway/IptvPaymentMethodsTask';
import SuperHighlightTask from './tasks/user/SuperHighlightTask';
import PayWayProfileTask from './tasks/payway/PayWayProfileTask';
import NpvrUploader from 'src/AAF/Npvr/NpvrUploader';
import { AAF_MODAL_HBO_PLAYBACK_ERROR, showModal } from 'src/actions/modal';


const { isPTVUSer, sendAuthdevice } = Resilence;

/* TODO This if will be removed. */
const platform = Device.getDevice().getPlatform();
const subPlatform = Object.prototype.toString.call(Device.getDevice().getSubplatform) === "[object Function]" ? Device.getDevice().getSubplatform() : '';
const isNagra = platform === 'nagra';
const isAndroid = platform === 'android';

export async function startHeaderInfo() {
    let result;
    try {
        const startHeaderInfoTask = new StartHeaderInfoTask();
        startHeaderInfoTask.setIsByHttps(Utils.isHttpsProtocol());
        const resultResponse = await RequestManager.addRequest(startHeaderInfoTask);
        result = resultResponse && resultResponse.data ? {...resultResponse, response: resultResponse.data} : resultResponse;

        checkSupportedRegion(platform, result.response.region);

        //TODO nagra hardcode solo deberia ser neceario para pruebas.
        let region = isNagra ? 'colombia' : result.response.region;
        let utc = result.response.utc || null;
        let timezone = result.response.timezone;
        // Youbora
        window.youboraRegion = region;

        //const regionStorage = storage.getItem('region');
        const regionLoggedStorage = storage.getItem('region');
        const HKS = result.response.session_stringvalue;
        const time = `${result.response.date} ${result.response.time}`;
        let server_time = null;
        console.log('[loader] starheaderinfo time: ' + time);
        console.info('[loader] starheaderinfo region', region);

        if (regionLoggedStorage && storage.getItem('user_hash') && regionLoggedStorage !== region) {
            console.info('[loader] starheaderinfo regionStorage', regionLoggedStorage);
            region = regionLoggedStorage;
            //TODO 3 hrs esta hardcode
            server_time = new Dates(time).add(0, 'h');
        } else {
            server_time = new Dates(time);
        }
        storage.setItem('region', region);
        // storage.setItem('region', 'argentina');
        storage.setItem('timezone', timezone);


        storage.setItem('HKS', typeof HKS !== 'undefined' ? HKS : '');
        console.log('[loader] starteaderinfo utc: ' + utc);
        if (utc) {
            EpgPersistence.setOffset(utc);
        }
        console.log('[loader] starheaderinfo needsOffset: ' + EpgPersistence.needsOffset());
        const timeToSet = EpgPersistence.needsOffset()
            ? new Dates(server_time).utcOffset(EpgPersistence.needsOffset(), true)
            : server_time;
        console.log('[loader] starheaderinfo timeToSet: ' + timeToSet);
        storage.setItem('server_time', timeToSet);

        let isZTE = subPlatform === 'zte' ? true : false;
        if (isZTE) {
            setTimeout(() => {
                storage.setItem('local_time', new Dates());
            }, 300);
        }
        else {
            storage.setItem('local_time', new Dates());
        }

        /* TODO This if will be removed. Android native need to refactor some things */
        if (isAndroid && window.AndroidPlayerInterface) {
            window.AndroidPlayerInterface.saveStartHeaderInfo(JSON.stringify(result));
        }
    } catch (err) {
        console.error('[loader] starheaderinfo err', err);
    }

    return new Promise((resolve, reject) => {
        resolve(result);
    });
}

function checkSupportedRegion(platform, region) {
    //Esta funcion revisa si la region esta soportada para aaf, de no se asi redirige hacia
    //la version anterior
    // https://dlatvarg.atlassian.net/browse/STV-4411
    const supportedRegions = [
        'mexico',
        'colombia',
        'chile',
        'argentina',
        'uruguay',
        'paraguay',
        'ecuador',
        'peru',
        'honduras',
        'nicaragua',
        'costarica',
        'dominicana',
        'panama',
        'elsalvador',
        'guatemala',
        'brasil'
    ];
    const xdk_redirect = getAppConfig().xdk_redirect;
    let isValidLocation = window.location.href.includes('aaf-stbnagra-preprod.clarovideo.net'); //remove hardcode QA preprod
    let isXDKRedirect = window.location.href.includes(xdk_redirect); //remove hardcode QA preprod

    if (isXDKRedirect) {
        storage.setItem('xdk', true);
        window.location.href = '/';
    }

    const hasXDKRedirect = storage.getItem('xdk') == 'true';

    if (!supportedRegions.includes(region) && !hasXDKRedirect && !isValidLocation) {
        let urlRedirect = '';
        const environment = env === 'test' ? env : '';
        const version = '392V17';
        const shortVersion = '392';
        const ps4Version = '392V18';
        switch (platform) {
            case 'samsung':
            case 'sony':
            case 'hisense':
            case 'opera':
                urlRedirect = `http://tv2${platform}${environment}.clarovideo.net/${version}/FRONTEND/`;
                break;
            case 'tizen':
                urlRedirect = `https://${platform}${environment}.clarovideo.net/${version}/FRONTEND/`;
                break;
            case 'ps4':
                urlRedirect = `http://playstation4${environment}.clarovideo.net/${ps4Version}/FRONTEND/`;
                break;
            case 'lg':
            case 'web0s':
                urlRedirect = `http://tv2lg${environment}.clarovideo.net/${shortVersion}/FRONTEND/`;
                break;
            case 'workstation':
                urlRedirect = `http://tv2sony${environment}.clarovideo.net/${version}/FRONTEND/`;
                break;
            case 'android':
            case 'nagra':
                //TODO: Estos dispositivos no tienen un endpoint productivo, no se redireccionan.
                break;
            default:
                break;
        }
        if (urlRedirect !== '') {
            console.log('[loader] Se redirecciona a versión productiva anterior: ' + urlRedirect);
            window.location.replace(urlRedirect);
        }
    }
}

export async function apaMetadata(region = '', appKey = '') {
    let result;
    try {
        const apaMetadataTask = new ApaMetadataTask(region, appKey);
        apaMetadataTask.setIsByHttps(Utils.isHttpsProtocol());
        result = await RequestManager.addRequest(apaMetadataTask);
        console.log('[apaMetadata]', result);
        /* TODO This if will be removed. Android native need to refactor some things */
        if (isAndroid && window.AndroidPlayerInterface) {
            window.AndroidPlayerInterface.saveApaMetadataTask(JSON.stringify(result));
        }
    } catch (err) {
        console.error('[apaMetadata] err: ', err);
    }
    return new Promise((resolve, reject) => {
        resolve(result);
    });
}

export async function apaMetadataMiddleware(region = '', appKey = '') {
    let result;
    try {
        const apaMetadataMiddlewareTask = new ApaMetadataMiddlewareTask(region, appKey);
        result = await RequestManager.addRequest(apaMetadataMiddlewareTask);
        /* TODO This if will be removed. Android native need to refactor some things */
        if (isAndroid && window.AndroidPlayerInterface) {
            await apaMetadata(region);
        }
    } catch (err) {
        console.error('[apaMetadataMiddleware] err: ', err);
    }
    return new Promise((resolve, reject) => {
        resolve(result);
    });
}

export async function apaAsset(region = '', appKey = '') {
    let result;
    try {
        const apaAssetTask = new ApaAssetTask(region, appKey);
        apaAssetTask.setIsByHttps(Utils.isHttpsProtocol());
        result = await RequestManager.addRequest(apaAssetTask);

        /* TODO This if will be removed. Android native need to refactor some things */
        if (isAndroid && window.AndroidPlayerInterface) {
            window.AndroidPlayerInterface.saveApaAssetTask(JSON.stringify(result));
        }
    } catch (err) {
        console.error('[apaAsset] err: ', err);
    }
    return new Promise((resolve, reject) => {
        resolve(result);
    });
}

export async function apaLegals(region = '') {
    let result;
    try {
        const apaLegalsTask = new ApaLegalsTask(region);
        apaLegalsTask.setIsByHttps(Utils.isHttpsProtocol());
        result = await RequestManager.addRequest(apaLegalsTask);

        /* TODO Not yet implemented on android */
        // if(isAndroid && window.AndroidPlayerInterface ){
        //     window.AndroidPlayerInterface.saveApaLegalsTask(JSON.stringify(result));
        // }
    } catch (err) {
        console.error('[apaLegals] err: ', err);
    }
    return new Promise((resolve, reject) => {
        resolve(result);
    });
}

export async function apaLauncher(region = '') {
    let result;
    try {
        const apaLauncherTask = new ApaLauncherTask(region);
        apaLauncherTask.setIsByHttps(Utils.isHttpsProtocol());
        apaLauncherTask.setRetriesNumber(0);
        result = await RequestManager.addRequest(apaLauncherTask);
    } catch (err) {
        console.error('[apaLauncher] err ', err);
        result = err;
    }
    //console.error("[loader.apaLauncher] ", result);
    return new Promise((resolve, reject) => {
        resolve(result);
    });
}

export async function badges(region = '') {
    let result;
    try {
        const badgesTask = new BadgesTask(region);
        result = await RequestManager.addRequest(badgesTask);
    } catch (err) {
        console.error('Error calling middleware badges: ', err);
    }
    return new Promise((resolve, reject) => {
        resolve(result);
    });
}

export async function fetchFavoriteLoader(user, filterList = null) {
    let result;
    const p = {
        user_hash: user.session_userhash,
        lasttouch: user.lasttouch ? user.lasttouch.favorited : null,
        //TODO: esto se platico con Rich y hasta la definicion final se quedara tentativamente asi.
        filterlist: filterList ? filterList : '30849'
    };

    try {
        let params = new UserFavoriteTask(p);
        result = await RequestManager.addRequest(params);
    } catch (err) {
        console.error('Error calling fetchFavoriteLoader: ', err);
    }
    return new Promise((resolve, reject) => {
        resolve(result);
    });
}

export async function pushSession(user_id, user_session) {
    let result;
    try {
        const pushSessionTask = new PushSessionTask(user_id, user_session);
        result = await RequestManager.addRequest(pushSessionTask);
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        console.error('Error PushSessionTask: ', err);
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function isLoggedIn() {
    let result;
    if (storage.getItem('IsLogOut')) {
        storage.unsetItem('IsLogOut');
        throw 'from IsLogOut';
    }
    try {
        const isIptv = storage.getItem('isIptv') || false;
        const isLoggedInTask = new IsLoggedInTask(true);

        result = isIptv && isIptv === "true" ? await loginByToken() : await RequestManager.addRequest(isLoggedInTask);

        if (result && result.response) {
            Utils.setHKS(result);
        }

        let response;
        if(result) {
            response = result.response || result.data;
        }
        if (response && response.region) {
            // Youbora
            window.youboraRegion = response.region;
            window.youboraUserId = response.user_id;

            const user_hash = response.session_userhash;
            const regionUser = response.region;
            const sub_region = response.subregion;
            const user_token = response.user_token;
            const regionStorage = storage.getItem('region');
            user_hash && storage.setItem('user_hash', user_hash);
            sub_region && storage.setItem('sub_region', sub_region);
            user_token && storage.setItem('user_token', user_token);
            user_token && AAF.Database.setUserToken(user_token);
            if (EpgPersistence.getTemp()) {
                EpgPersistence.setSubRegion(sub_region);
            }

            if (regionUser !== regionStorage) {
                storage.setItem('region', regionUser);
                console.info('[loader] isloggedin region', regionUser);
                window.location.href = '/';
            }
            // Youbora: data para youbora
            const config = getAppConfig();
            if (
                result.response &&
                Array.isArray(window.youboraParams) &&
                window.youboraParams.length > 0
            ) {
                console.log('[result.response]', result.response);
                if(result.data) {
                    if (result.response.paywayProfile && result.response.paymentMethods) {
                        const paymentMethodsKeys = Object.keys(result.response.paymentMethods);
                        let param1 = new Set();
                        paymentMethodsKeys.map(paymentMethod => {
                            if(result.response.paymentMethods[paymentMethod]) {
                                param1.add(paymentMethod);

                            }
                        });
                        param1 = Array.from(param1)
                        .map(String)
                        .join('-');
                        window.youboraParams[0].value = param1;
                    }
                } else {
                    if (result.response.paywayProfile && result.response.paywayProfile.paymentMethods) {
                        result.response.paywayProfile.paymentMethods.map(item => {
                            let param1 = new Set();
                            param1.add(item.user_category);
                            param1 = Array.from(param1)
                                .map(String)
                                .join('-');
                            window.youboraParams[0].value = param1;
                        });
                    }
                }

                //* Youbora: data para youbora
                setYouboraData(
                    result.response.email || '',
                    result.response.region || '',
                    (result.entry && result.entry.device_id) || config.device_id || '',
                    sub_region || ''
                );

                console.log('IsLoggedInTask result.response', result.response);
            }

            // Se settea la respuesta correcta a android

            if (isAndroid && window.AndroidPlayerInterface) {
                window.AndroidPlayerInterface.saveIsLoggedIn(JSON.stringify(result));
            }
        }
        // Si no es respuesta correcta se deja el caché inmediato
        // anterior en android
        else {
            if (isAndroid && window.AndroidPlayerInterface) {
                let currentParams = isLoggedInTask.getParams();
                const user = store.getState().user;
                const response = {
                    entry: currentParams,
                    response: user
                };
                window.AndroidPlayerInterface.saveIsLoggedIn(JSON.stringify(response));
            }
        }

        // Youbora
        youboraLauncher();
    } catch (err) {
        console.error('Error calling isLoggedInTask: ', err);
    }

    const status = await checkAccountStatus(result);
    result = {
        ...result,
        response : {
            ...result.response,
            isSuspendedAccount:status === STATUS_ACCOUNT_SUSPENDED
        },
    }

    return new Promise((resolve, reject) => {
        resolve(result);
    });
}

/**
 * Accede al nuevo servicio de isloggedin
 * @param {*} email string, user email
 */
export async function loginDynamicCM(email) {
    let result;
    try {
        const loginDynamicTask = new LoginDynaminTask(email, true, null);
        result = await RequestManager.addRequest(loginDynamicTask);
    } catch (err) {
        console.error('Error calling loginDynamicTask: ', err);
    }

    return new Promise((resolve, reject) => {
        resolve(result);
    });
}

export async function loginDynamicAkamaiMfwk(email) {
    let result;
    try {
        const loginDynaminTask = new LoginDynaminTask(email);
        result = await RequestManager.addRequest(loginDynaminTask);
    } catch (err) {
        console.error('Error calling loginDynamicTask: ', err);
    }
    return new Promise((resolve, reject) => {
        resolve(result);
    });
}

export async function loginDynamic(email) {
    return settings.music_use_login_dynamic_cm_middleware
        ? loginDynamicCM(email)
        : loginDynamicAkamaiMfwk(email);
}

export async function editMusicUserProfile(user, userTV) {
    let result;
    try {
        const email = userTV.email;
        const name = userTV.firstname;
        const lastName = userTV.lastname;
        const bornDate = userTV.bornDate || '01/01/1912';
        const sex = userTV.sex || 'M';
        const headers = {
            'Content-Type': 'application/json'
        };
        const editMusicUserTask = new MusicTask(
            'settings/editUserProfileSTV',
            user,
            { method: 'POST', email, name, lastName, bornDate, sex, countryCode: user.countryCode },
            headers
        );
        result = await RequestManager.addRequest(editMusicUserTask);
    } catch (err) {
        console.error('Error calling editMusicUserProfile: ', err);
    }

    return new Promise((resolve, reject) => {
        resolve(result);
    });
}

export async function UserSeenLast(group_id) {
    let result;
    try {
        const UserSeenLastTask1 = new UserSeenLastTask(group_id);
        result = await RequestManager.addRequest(UserSeenLastTask1);
        return new Promise(resolve => {
            resolve(result.response);
        });
    } catch (err) {
        console.error('Error calling UserSeenLast: ', err);
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function linealChannels(userId = null) {
    let result;
    try {
        const linealChannelsTask = new LinealChannelsTask(userId);
        result = await RequestManager.addRequest(linealChannelsTask);

        // Youbora
        if (Array.isArray(window.youboraParams) && window.youboraParams.length > 0) {
            if (result && result.response && result.response.paqs && result.response.paqs.paq) {
                result.response.paqs.paq.map(item => {
                    // if(item.key) window.youboraParams[1].value += (window.youboraParams[1].value.length===0) ? item.key : '-'+item.key;
                    // if(item.key) window.youboraParams[2].value = item.key;
                    if (item.paymentmethod && item.paymentmethod.gateway)
                        window.youboraParams[5].value = item.paymentmethod.gateway;
                });
            }
        }

        return new Promise((resolve, reject) => {
            // For debug:
            //result = {"entry":{"HKS":"rpl4p8ks6cnp9o87a8m81p3uh6","api_version":"v5.8","authpn":"amco","authpt":"12e4i8l6a581a","device_category":"tv","device_manufacturer":"sony","device_model":"sony","device_type":"tv","device_id":"cacddd6d-d6b3-11a8-25ea-b6cba4f568aa","device_name":"sony","device_so":"default","region":"mexico","format":"json","user_id":"19258976"},"response":{"paqs":{"paq":[{"name":"TVGRT","offerid":"","purchaseid":"","play":"1","npvrstorage":"","timeshift":"","payway_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoxOTI1ODk3NiwibmFtZSI6IlRWR1JUIiwib2ZmZXJpZCI6IiIsInB1cmNoYXNlaWQiOiIiLCJwbGF5IjoiMSIsIm9iamVjdF9pZCI6IiIsIm5wdnJzdG9yYWdlIjoiIiwidGltZXNoaWZ0IjoiIiwiZ3JvdXBzIjoiNzU1NDAyLDczOTQ4OSw3MjUyMDksNzE3MDI0In0.zYugVLCdIBaUEFJqfqjGDsSj5xPxF8Y3y2YZK2XjkQU","groups":"755402,739489,725209,717024"},{"name":"FOX","offerid":"14327208","purchaseid":"259955052","play":"1","npvrstorage":"24","timeshift":"24","payway_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoxOTI1ODk3NiwibmFtZSI6IkZPWCIsIm9mZmVyaWQiOiIxNDMyNzIwOCIsInB1cmNoYXNlaWQiOiIyNTk5NTUwNTIiLCJwbGF5IjoiMSIsIm9iamVjdF9pZCI6IjI2ODAiLCJucHZyc3RvcmFnZSI6IjI0IiwidGltZXNoaWZ0IjoiMjQiLCJncm91cHMiOiI3NjI3NTQsNzYyNzg1LDc2MjgwMCw3NjI3NjksNzYyNzg4LDc2Mjc2OCw3NjI3NzAsNzYyNzg3LDc2MjgwMiw3NjI3ODYsNzYyODAxLDc1Mzk5NCw3NDY0NzgsNzQ1NzM2LDc0NTgzMiw3NDU5MjEsNzQ1OTIwLDc0NTkzOSJ9.lDZpKtkPLITMHtSobInnNoLkNK-VC-HtS4af1oTjlr0","groups":"762754,762785,762800,762769,762788,762768,762770,762787,762802,762786,762801,753994,746478,745736,745832,745921,745920,745939"},{"name":"HBO","offerid":"14327084","purchaseid":"261780866","play":"1","npvrstorage":"","timeshift":"","payway_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoxOTI1ODk3NiwibmFtZSI6IkhCTyIsIm9mZmVyaWQiOiIxNDMyNzA4NCIsInB1cmNoYXNlaWQiOiIyNjE3ODA4NjYiLCJwbGF5IjoiMSIsIm9iamVjdF9pZCI6bnVsbCwibnB2cnN0b3JhZ2UiOiIiLCJ0aW1lc2hpZnQiOiIiLCJncm91cHMiOiI3NTA5MTEifQ.xR3-7oPm3iiPm4Zy-W8s63jA3Iv6hP82kbENKiJc4Hk","groups":"750911"}]}},"status":"0","msg":"OK"};
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function activateControlPin(params = {}) {
    let result;
    try {
        const activateControlPinTask = new ActivateControlPinTask(params);
        result = await RequestManager.addRequest(activateControlPinTask);
        if (result.data) {
            result.status = '0';
        }

        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function activateControlPinWithoutEmail(params = {}) {
    let result;
    try {
        const activateControlPinWithoutEmailTask = new ActivateControlPinWithoutEmailTask(params);
        result = await RequestManager.addRequest(activateControlPinWithoutEmailTask);
        if (result.data) {
            result.status = '0';
        }
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function changeControlPin(params = {}) {
    let result;
    try {
        const changeControlPinTask = new ChangeControlPinTask(params);
        result = await RequestManager.addRequest(changeControlPinTask);
        if (result.data) {
            result.status = '0';
        }
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function checkControlPin(params = {}) {
    let result;
    try {
        const checkControlPinTask = new CheckControlPinTask(params);
        result = await RequestManager.addRequest(checkControlPinTask);
        if (result.data) {
            result.status = '0';
        }
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function remindControlPin(params = {}) {
    let result;
    try {
        const remindControlPinTask = new RemindControlPinTask(params);
        result = await RequestManager.addRequest(remindControlPinTask);
        if (result.data) {
            result.status = '0';
        }
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function modifyControlPin(params = {}) {
    let result;
    try {
        const modifyControlPinTask = new ModifyControlPinTask(params);
        result = await RequestManager.addRequest(modifyControlPinTask);
        if (result.data) {
            result.status = '0';
        }
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function register(params = {}) {
    let result;
    try {
        const registerTask = new RegisterTask(params);
        result = await RequestManager.addRequest(registerTask);
        const sub_region = result.response.subregion;
        if (result && result.response) {
            Utils.setHKS(result);
        }

        // Youbora
        window.youboraRegion = result.response.region;
        window.youboraUserId = result.response.user_id;
        youboraLauncher();

        // Youbora: data para youbora
        if (
            result.response &&
            Array.isArray(window.youboraParams) &&
            window.youboraParams.length > 0
        ) {
            if (result.response.paywayProfile && result.response.paywayProfile.paymentMethods) {
                result.response.paywayProfile.paymentMethods.map(item => {
                    let param1 = new Set();
                    param1.add(item.user_category);
                    param1 = Array.from(param1)
                        .map(String)
                        .join('-');
                });
            }

            //youbora
            window.youboraParams[4].value = result.response.email || '';
            window.youboraParams[8].value = result.response.region || '';
            window.youboraParams[10].value = result.entry.device_id || '';
            window.youboraParams[15].value = sub_region || '';
        }

        // Youbora
        youboraLauncher();

        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function login(params = {}, mwfkURL = null) {
    let result;
    try {
        const queryParams = params;
        let bodyParams = {};
        if (params.username && params.password && params.email) {
            bodyParams = {
                username: params.username,
                password: params.password
            };
            queryParams.username = null;
            queryParams.password = null;
            queryParams.email = null;
        }

        const loginTask = new LoginTask(queryParams, bodyParams, mwfkURL);

        loginTask.setIsByHttps(Utils.isHttpsProtocol());
        result = await RequestManager.addRequest(loginTask);
        const sub_region = result.response.subregion;
        console.log('IsLoggedInTask LoginTask', result);

        if (result && result.response) {
            if(result.response.user_token) {
                storage.setItem('user_token', result.response.user_token);
                AAF.Database.setUserToken(result.response.user_token);
            }
            Utils.setHKS(result);
        }

        // Youbora
        window.youboraRegion = result.response.region;
        window.youboraUserId = result.response.user_id;
        youboraLauncher();

        // Youbora: data para youbora
        if (
            result.response &&
            Array.isArray(window.youboraParams) &&
            window.youboraParams.length > 0
        ) {
            console.log('[result.response]', result.response);
            if (result.response.paywayProfile && result.response.paywayProfile.paymentMethods) {
                result.response.paywayProfile.paymentMethods.map(item => {
                    let param1 = new Set();
                    param1.add(item.user_category);
                    param1 = Array.from(param1)
                        .map(String)
                        .join('-');
                });
            }

            //youbora
            window.youboraParams[4].value = result.response.email || '';
            window.youboraParams[8].value = result.response.region || '';
            window.youboraParams[10].value = result.entry.device_id || '';
            window.youboraParams[15].value = sub_region || '';

            console.log('IsLoggedInTask result.response', result.response);
        }

        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function login360(params = {}) {
    let result;
    try {
        const login360Task = new Login360Task(params);
        result = await RequestManager.addRequest(login360Task);
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function loginNET(params = {}) {
    let result;
    try {
        const loginNETTask = new LoginNETTask(params);
        result = await RequestManager.addRequest(loginNETTask);
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

// NUEVOS MÉTODOS DE LOGIN DE CLAROMUSICA
export async function loginCMByEmail(params = {}) {
    let result;
    try {
        const loginCMByEmailTask = new LoginCMByEmailTask(params);
        result = await RequestManager.addRequest(loginCMByEmailTask);
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function loginCMByPhone(params = {}) {
    let result;
    try {
        const loginCMByPhoneTask = new LoginCMByPhoneTask(params);
        result = await RequestManager.addRequest(loginCMByPhoneTask);
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function CpfQuery(params = {}) {
    let result;
    try {
        const cpfQueryTask = new CpfQueryTask(params);
        result = await RequestManager.addRequest(cpfQueryTask);
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function sendPasswordReminder(params = {}) {
    let result;
    try {
        const sendPasswordReminderTaks = new SendPasswordReminderTaks(params);
        result = await RequestManager.addRequest(sendPasswordReminderTaks);
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function setTermsAndConditions(params = {}) {
    let result;
    try {
        const setTermsAndConditionsTask = new SetTermsAndConditionsTask(null, params);
        result = await RequestManager.addRequest(setTermsAndConditionsTask);
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function workflowstart(params = {}) {
    params.validateLogin = params.validateLogin === undefined ? true : params.validateLogin;
    let result;
    const workflowTask = new WorkflowTask(params);
    try {
        result = await RequestManager.addRequest(workflowTask);
    } catch (err) {
        console.error('Error calling workflowstart: ', err);

        // Si hay error de usuario no logueado, entonces llamar sendAuthDevice
        const isIPTV = isPTVUSer();

        if (isIPTV && err.code === 'loggin_required') {
            try {
                const authdeviceResponse = await sendAuthdevice();
                // result = await RequestManager.addRequest(workflowTask);
                return new Promise((resolve, reject) => reject("Workflowstart retry"));
            } catch (error) {
                console.error("Error calling sendAuthdevice", error);
                return new Promise((resolve, reject) => reject(err));
            }
        }
        return new Promise((resolve, reject) => reject(err));
    }
    return new Promise((resolve, reject) => {
        if (result && result.status === '0') {
            resolve(result);
        } else {
            reject(result);
        }
    });
}

export async function paywayConfirm(url, params = {}, method, postParams, showErrorModal = true) {
    let result;
    try {
        const confirmTask = new ConfirmTask(url, params, method, postParams, showErrorModal);
        result = await RequestManager.addRequest(confirmTask);
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function smartCardLogin() {
    let result;
    try {
        const smartCardLoginTask = new SmartCardLoginTask();
        result = await RequestManager.addRequest(smartCardLoginTask);
        //  const HKS = result.response.data.session_stringvalue;
        // storage.setItem('HKS', HKS);

        if (result && result.response && result.response.data) {
            storage.setItem('region', result.response.data.region);
            // storage.setItem('region',result.response.region);
            storage.setItem('user_hash', result.response.data.session_userhash);
        }
    } catch (err) {
        console.error('Error calling smartCardLoginTask: ', err);
    }
    return new Promise((resolve, reject) => {
        if (result && result.status === '0') {
            resolve(result);
        } else {
            reject(result);
        }
    });
}

export async function authdevice(params = {}) {
    let result;
    try {
        const authdevicenTask = new authdeviceTask(params);
        result = await RequestManager.addRequest(authdevicenTask);
        if (result && result.response) {
            Utils.setHKS(result);
            authdeviceInterceptor(result.response);
        }
        console.log('authdeviceTask', result);
        if (result && result.response && result.response.data) {
            storage.setItem('region', result.response.data.region);
            // storage.setItem('region',result.response.region);
            storage.setItem('user_hash', result.response.data.session_userhash);
        }
    } catch (err) {
        result = err;
        console.error('Error calling auth: ', err);
    }
    return new Promise((resolve, reject) => {
        if (result && result.status === '0') {
            resolve(result);
        } else {
            reject(result);
        }
    });
}

//* NUEVO MÉTODO DE AUTHDEVICE
export async function authdeviceV1(params = {}) {
    let result;
    console.log('[loader]:: authdeviceV1Task 01', params);

    try {
        const authDevicenV1Task = new authdeviceV1Task(params);
        result = await RequestManager.addRequest(authDevicenV1Task);
        console.log('[loader]:: authdeviceV1Task 02', result.data);

        if (result && result.data) {
            storage.setItem('CMR_Experience_Token', result.data.token);
            console.log('[loader]:: authdeviceV1Task 03', result.data.token);
        }
        console.log('[loader]:: authdeviceV1Task 04 ya lo guardo', result.data.token);
    } catch (err) {
        result = err;
        console.error('[loader]:: Error calling authDevice V1: ', result);
        throw result;
    }

    return result;
}

//* NUEVO MÉTODO DE SUPERHIGHLIGHT

async function getSuperHighlight() {
  let result;

  try {
    const getSuperHighlightTask = new SuperHighlightTask();
    const request = await RequestManager.addRequest(getSuperHighlightTask);
    result = request;
    console.log('[loader]:: getSuperHighlightTask 02', request);

  } catch (err) {
      result = err;
      console.error('[loader]:: Error calling getSuperHighlightTask: ', result);
      throw result;
  }

  return result;
}

//* NUEVO MÉTODO DE IPTV PAYMENT METHODS

export async function getIPTVPaymentMethods() {
    let result;

    try {
        const getIPTVPaymentMethodsTask = new IptvPaymentMethodsTask({});
        const request = await RequestManager.addRequest(getIPTVPaymentMethodsTask);
        result = request;
        console.log('[loader]:: getIPTVPaymentMethods 02', request);

    } catch (err) {
        result = err;
        console.error('[loader]:: Error calling getIPTVPaymentMethods: ', result);
        throw result;
    }

    return result;
}

//* NUEVO MÉTODO DE PAYMENT DATA

export async function getPaymentProfile() {
  let result;

    try {
        const getPaymentProfileTask = new PayWayProfileTask();
        const request = await RequestManager.addRequest(getPaymentProfileTask);
        result = request;
        console.log('[loader]:: PayWayProfileTask', request);

    } catch (err) {
        result = err;
        console.error('[loader]:: Error calling PayWayProfileTask: ', result);
        throw result;
    }

    return result;
}

const getParamSuscription = (result) => {
  const subscriptions = result && result.response ? result.response.subscriptions : [];
  const valueSuscriptions = {}
  const AMCO_SUBSCRIPTIONS = ["CV_SEMANAL", "CV_MENSUAL", "CV_ANUAL"]

  if(subscriptions && subscriptions.length > 0){
    subscriptions.map(item => {
      const validateName = AMCO_SUBSCRIPTIONS.includes(item.name) ? "AMCO" : item.name
      valueSuscriptions[validateName] = true
    });
    return valueSuscriptions;
  }else {
    return valueSuscriptions;
  }
}

const getParamHasUserSusc = (suscriptions) => {
  return Object.keys(suscriptions).length > 0 ? 1 : 0;
}

const getPaymentMethods = (payment_method) => {
  return payment_method && payment_method !== "" ? {[payment_method]: true} : {};
}

const getHasSavedPayway = (payment_method) => {
  return payment_method && payment_method !== "" ? 1 : 0;
}

function addInfoNewDataLogin(result, isIptv, payment_method, superhighlight, respsuscriptions) {
  const subscriptions = getParamSuscription(respsuscriptions);
  const paywayProfile = respsuscriptions.response;
  const hasUserSusc = getParamHasUserSusc(subscriptions);
  const paymentMethods = getPaymentMethods(payment_method)
  const hasSavedPayway = getHasSavedPayway(payment_method)

  const transformData = {
    ...result.data,
    isIptv,
    superhighlight,
    subscriptions,
    hasUserSusc,
    paywayProfile,
    paymentMethods,
    hasSavedPayway
  };

  return {
      ...result,
      data: transformData,
      response: transformData
    }
}

async function setDataLogin(result) {
  let modifyDataPaymentMethods;
  try {
    const iptvPaymentMethods = await getIPTVPaymentMethods();
    const superHighlight = await getSuperHighlight();
    const dataExtraPayment = await getPaymentProfile();

    const validateNewValues = iptvPaymentMethods && iptvPaymentMethods.response && superHighlight && superHighlight.data && dataExtraPayment && dataExtraPayment.response;

    if(validateNewValues){
      const { isIptv = false, payment_method = "" } = iptvPaymentMethods.response;
      const { superhighlight = [] } = superHighlight.data;
      modifyDataPaymentMethods = addInfoNewDataLogin(result, isIptv, payment_method, superhighlight, dataExtraPayment)
    }else {
      modifyDataPaymentMethods = result;
    }
  } catch (error) {
    modifyDataPaymentMethods = result;
    console.error('[loader]:: Error calling setDataLogin: ', modifyDataPaymentMethods);
    throw modifyDataPaymentMethods;
  }

  return modifyDataPaymentMethods
}

//* NUEVO MÉTODO DE LOGIN BY TOKEN

export async function loginByToken(params = {}) {
  let result;
  console.log('[loader]:: loginByToken 01', params);

    try {
        const loginnByTokenTask = new LoginByTokenTask(params);
        const response = await RequestManager.addRequest(loginnByTokenTask);
        if(response && response.data && response.data.user_token) {
            storage.setItem('user_token', response.data.user_token);
            AAF.Database.setUserToken(response.data.user_token);
        }
        result = await setDataLogin(response);
        console.log('[loader]:: loginByToken 02', result.data);

        if (result && result.data) {
            //* Mandar a localstorage
            storage.setItem('region', result.data.region);
            storage.setItem('user_hash', result.data.session_userhash);
            storage.setItem('isIptv', result.data.isIptv);
            Utils.setHKS(result);
            authdeviceInterceptor(result.data);
            console.log('[loader]:: loginByToken 03', result.data);

        }
    } catch (error) {
        result = error;
        console.error('[loader]:: Error calling loginByToken: ', result);
        storage.setItem('user_token', '');
        AAF.Database.setUserToken(null);
        throw result;
    }

  return result;
}

//* NUEVO MÉTODO DE QUERY USER SYNC

export async function queryUserSync(params = {}) {
    let result;
    console.log('[loader]:: queryUserSync', params);

    try {
        const queryUserSyncTask = new QueryUserSyncTask(params);
        result = await RequestManager.addRequest(queryUserSyncTask);
        //* Checar response de la API
        console.log('[loader]:: queryUserSync', result);

    } catch (err) {
        result = err;
        console.error('[loader]:: Error calling queryUserSync: ', err);
    }

    return result;
}

export async function refreshToken() {
    let result;
    try {
        const refreshTokenTask = new RefreshTokenTask();
        result = await RequestManager.addRequest(refreshTokenTask);
        if (result && result.data) {
            storage.setItem('user_token', result.data);
            AAF.Database.setUserToken(result.data);
            /**
             * Actualuzar el user token de los recordings
             */
            const recordingsUser = NpvrUploader.getUser();
            recordingsUser.user_token = result.data;
            NpvrUploader.setUser(recordingsUser);
            
            store.dispatch(receiveUserToken(result.data))
        }
    } catch (error) {
        result = error;
        console.error('[loader]:: Error calling refreshToken: ', result);
        throw result;
    }
}

export async function navData() {
    let result;
    try {
        const navDataTask = new NavDataTask();
        result = await RequestManager.addRequest(navDataTask);
    } catch (err) {
        console.error('Error calling navData: ', err);
    }
    return new Promise((resolve, reject) => {
        if (result && result.status === '0') {
            resolve(result.response.nodes);
        } else {
            reject(result);
        }
    });
}

export async function contentData(groupId = '') {
    let result;
    try {
        const contentDataTask = new ContentDataTask(groupId);
        result = await RequestManager.addRequest(contentDataTask);
    } catch (err) {
        console.error('Error calling contentData: ', err);
    }
    return new Promise((resolve, reject) => {
        if (result && result.status === '0') {
            resolve(result.response);
        } else {
            result = false;
            reject(result);
        }
    });
}

export async function contentSerie(groupId = '') {
    let result;
    try {
        const contentSerieTask = new ContentSerieTask(groupId);
        result = await RequestManager.addRequest(contentSerieTask);
    } catch (err) {
        console.error('Error calling contentSerie: ', err);
        return result;
    }
    return new Promise((resolve, reject) => {
        if (result && result.status === '0') {
            Utils.setTitleSerie(result)
            resolve(result.response);
        } else {
            reject(result);
        }
    });
}

export function getBookmark(groupId = '') {
    let result;
    try {
        const getBookmarkTask = new GetBookmarkTask(groupId);
        result = RequestManager.addRequest(getBookmarkTask);
    } catch (err) {
        console.error('Error calling getBookmark: ', err);
    }
    return result;
}

export function getMultiContentSearch(groupsId = null) {
    let result;
    try {
        const getMultiContentSearchTask = new MultiContentSearchTask(groupsId);
        result = RequestManager.addRequest(getMultiContentSearchTask);
    } catch (err) {
        console.error('Error calling getMultiContentSearchTask: ', err);
    }
    return result;
}

export function getMultiplePBIS(groupIds = null, withoutToken = false) {
    let result;
    try {
        const getMultiplePbis = new MultiPurchaseButtonInfo(groupIds, withoutToken);
        getMultiplePbis.setIsByHttps(false);
        result = RequestManager.addRequest(getMultiplePbis);
    } catch (err) {
        console.error('[JONY]-Error calling getMultiplePBIS: ', err);
    }
    return result;
}

export async function purchaseButtonInfo(groupId = '', islive = null, validateLogin = true) {
    let result;
    const isIPTV = isPTVUSer();
    try {
        let purchaseButtonInfoTask;
        if(isIPTV) {
            purchaseButtonInfoTask = new PurchaseButtonInfoTask(groupId, islive, validateLogin);
        } else {
            purchaseButtonInfoTask = new PurchaseButtonInfoTask(groupId, islive, false);
        }
        result = await RequestManager.addRequest(purchaseButtonInfoTask);
    } catch (err) {
        console.error('Error calling purchaseButtonInfo: ', err);

        // Si hay error de usuario no logueado, entonces llamar sendAuthDevice
        // y retomar la llamada a PurchaseButtonInfo

        if (isIPTV && err.code === 'loggin_required') {
            try {
                await sendAuthdevice()
                const purchaseButtonInfoTask = new PurchaseButtonInfoTask(groupId, islive, validateLogin);
                result = await RequestManager.addRequest(purchaseButtonInfoTask);
            } catch (err) {
                console.error("Error calling sendAuthdevice", err);
            }
        }
        else if (err.completeError && err.completeError.response) {
            return new Promise((resolve, reject) => {
                resolve(err.completeError.response);
            });
        }
    }
    return new Promise((resolve, reject) => {
        if (result && result.status === '0') {
            resolve(result.response);
        } else {
            reject(result);
        }
    });
}

export async function PurchaseButtonInfov585(params) {
    let result;
    const { groupId, islive, validateLogin = true } = params;
    // Si hay error de usuario no logueado, entonces llamar sendAuthDevice
    // y retomar la llamada a PurchaseButtonInfo
    const isIPTV = isPTVUSer();
    let purchaseButtonInfoTask;
    try {
        if(isIPTV) {
            purchaseButtonInfoTask = new PurchaseButtonInfov585Task({ groupId, islive, validateLogin });
        }
        else {
            purchaseButtonInfoTask = new PurchaseButtonInfov585Task({ groupId, islive, validateLogin: false });
        }

        result = await RequestManager.addRequest(purchaseButtonInfoTask);
    } catch (err) {
        console.error('Error calling purchaseButtonInfov585: ', err);
        if (isIPTV && err.code === 'loggin_required') {
            try {
                await sendAuthdevice()
                purchaseButtonInfoTask = new PurchaseButtonInfov585Task({ groupId, islive, validateLogin });
                result = await RequestManager.addRequest(purchaseButtonInfoTask);
            } catch (err) {
                console.error("Error calling sendAuthdevice", err);
            }
        }
        else if (err.completeError && err.completeError.response) {
            return new Promise((resolve, reject) => {
                resolve(err.completeError.response);
            });
        }
    }
    return new Promise((resolve, reject) => {
        if (result && result.status === '0') {
            resolve(result.response);
        } else {
            reject(result);
        }
    });
}

export async function contentRecomendations({ groupId = '', quantity = 10, is_only_provider = false }, showRecommendations = true) {
    let result;
    try {
        const contentRecommendationsTask = new ContentRecommendationsTask(
            groupId,
            quantity,
            Utils.getApaMetadataKey('byr_filterlist_configuration', '{}', 'filterlist'),
            is_only_provider,
            showRecommendations,
        );
        result = await RequestManager.addRequest(contentRecommendationsTask);
    } catch (err) {
        result = null;
        console.error('Error calling contentRecomendations: ', err);
    }
    return new Promise((resolve, reject) => {
        if (result && result.status === '0') {
            resolve(result.response.groups || []);
        } else {
            resolve([]);
        }
        return new Promise((resolve, reject) => {
            if (result && result.status === '0') {
                resolve(result.response.groups || []);
            } else {
                resolve([]);
            }
        });
    });
}

export async function playerGetMedia(
    groupId = '',
    contentId = '',
    isTrailer = false,
    streamType = '',
    startTime = '',
    endTime = '',
    payway_token = '',
    showErrorModal,
    extraParamsEmitter = null
) {
    console.log('[FASTTRACKING] es fast play, se manda a llamar la getmedia en loader', extraParamsEmitter);
    let result;

    try {
        const playerGetMediaTask = new PlayerGetMediaTask(
            groupId,
            contentId,
            isTrailer,
            streamType,
            startTime,
            endTime,
            payway_token,
            showErrorModal,
            extraParamsEmitter
        );
        result = await RequestManager.addRequest(playerGetMediaTask);
        console.info('[loader.playerGetMedia]', result);
    } catch (err) {
        console.error('Error calling playerGetMedia: ', err);
        result = err;
    }
    return new Promise((resolve, reject) => {
        console.info('[loader.playerGetMedia]', result);
        // Hardcoded para max devices o cualquier error 400 de pgm
        // result = {"entry":{"group_id":"753994","stream_type":"smooth_streaming","preview":"0","HKS":"41kcjksnq9p6mnjsjti1127hk6","api_version":"v5.82","authpn":"amco","authpt":"12e4i8l6a581a","device_category":"tv","device_manufacturer":"hisense","device_model":"hisense","device_type":"tv","device_id":"4480b11c-9530-ce6e-faae-d18e13a88079","device_name":"hisense","device_so":"2.4.2","region":"mexico","format":"json"},"status":400,"errors":[{"message":"You have reached the maximum number of devices in your account","code":"PLY_DEV_00006","exception":"L2luZXRwdWIvc2VydmljZXMvc3JjL0FtY28vRGV2aWNlLnBocCA0MzU="}]};

        if (result.status == '200' || result.status == '400' || result.status == 500) {
            if (result.status == '200') {
                // Guardar entry para manejar errores durante pérdida de internet mientras el player esta reproduciendo
                result.response.entry = result.entry;
                resolve(result.response);

                if (result.response && result.response.user && result.response.user.lasttouch) {
                    store.dispatch(setLastTouchSeen(result.response.user.lasttouch));
                }
            }
            if (result.status == '400' || result.status == 500) {
                resolve(result);
            }
        } else {
            reject(result);
            if(result.code){
                const modalProps = {
                    errorCode: result.code,
                    groupId: groupId
                };
                store.dispatch(
                    showModal({
                        modalType: AAF_MODAL_HBO_PLAYBACK_ERROR,
                        modalProps: modalProps
                    })
                );
            }
        }
    });
}

export async function verticalLookUp(value, field, from, quantity) {
    let result;
    try {
        const verticalLookUpTask = new VerticalLookUp(value, field, from, quantity);
        result = await RequestManager.addRequest(verticalLookUpTask);
    } catch (err) {
        console.error('Error calling verticalLookUp: ', err);
    }
    return new Promise((resolve, reject) => {
        if (result.status == '0') {
            resolve(result.response.groups);
        } else {
            reject(result);
        }
    });
}

export async function vertical(value, field, provider_id, from, quantity, id_rol = "") {
    let result;
    try {
        const verticalTask = new Vertical(value, field, provider_id, from, quantity, id_rol);
        result = await RequestManager.addRequest(verticalTask);
    } catch (err) {
        console.error('Error calling verticalLookUp: ', err);
    }
    return new Promise((resolve, reject) => {
        if (result.status == '0') {
            resolve(result.response.groups);
        } else {
            reject(result);
        }
    });
}

export async function deviceAttach(groupId, purchase_id = '') {
    let result;
    try {
        const deviceAttachTask = new DeviceAttachTask(groupId, 0, purchase_id);
        result = await RequestManager.addRequest(deviceAttachTask);
        return Promise.resolve(result.response);
    } catch (err) {
        console.error('Error calling deviceAttach: ', err);
        return Promise.reject(err);
    }
}

export async function getAppVersion() {
    let result;
    try {
        const appVersionTask = new AppVersionTask();
        result = await RequestManager.addRequest(appVersionTask);
        return Promise.resolve(result.response);
    } catch (err) {
        console.error('Error calling appVersionTask ', err);
        return Promise.reject(err);
    }
}

export async function getEpgVersionFromService() {
    let result;
    try {
        const epgVersionTask = new EpgVersionTask();
        result = await RequestManager.addRequest(epgVersionTask);
        if (result && result.response && result.response) return Promise.resolve(result.response);
        else return Promise.resolve(null);
    } catch (err) {
        console.error('[EpgVersionStatus] Error calling epgVersionTask ', err);
        return Promise.resolve(null);
    }
}

export async function getAvatar() {
    let result;
    try {
        const avatarsTask = new AvatarsTask();
        result = await RequestManager.addRequest(avatarsTask);
        if (result && result.response && result.response) return Promise.resolve(result.response);
        else return Promise.resolve(null);
    } catch (err) {
        console.error('[getAvatar] Error calling AvatarsTask ', err);
        return Promise.resolve(err);
    }
}
export async function createProfile(params) {
    let result;
    try {
        const createProfileTask = new CreateProfileTask(params);
        result = await RequestManager.addRequest(createProfileTask);
        return Promise.resolve(result);
    } catch (err) {
        console.error('[createProfile] Error calling createProfileTask ', err);
        return Promise.resolve(err);
    }
}
export async function deleteProfile(params) {
    let result;
    try {
        const deleteProfileTask = new DeleteProfileTask(params);
        result = await RequestManager.addRequest(deleteProfileTask);
        return Promise.resolve(result);
    } catch (err) {
        console.error('[deleteProfile] Error calling deleteProfileTask ', err);
        return Promise.resolve(err);
    }
}
export async function readProfile(params) {
    let result;
    try {
        const readProfileTask = new ReadProfileTask(params);
        result = await RequestManager.addRequest(readProfileTask);
        if (result && result.response && result.response) return Promise.resolve(result.response);
        else return Promise.resolve(null);
    } catch (err) {
        console.error('[readProfile] Error calling readProfileTask ', err);
        return Promise.resolve(err);
    }
}
export async function updateProfile(params) {
    let result;
    try {
        const updateProfileTask = new UpdateProfileTask(params);
        result = await RequestManager.addRequest(updateProfileTask);
        return Promise.resolve(result);
    } catch (err) {
        console.error('[updateProfile] Error calling updateProfileTask ', err);
        return Promise.resolve(err);
    }
}

export async function addFavorite(groupId) {
    let result;
    try {
        const addFavoriteTask = new AddFavoriteTask(groupId);
        result = await RequestManager.addRequest(addFavoriteTask);
        return Promise.resolve(result);
    } catch (err) {
        console.error('[addFavorite] Error calling AddFavoriteTask ', err);
        return Promise.resolve(err);
    }
}

export async function deleteFavorite(groupId, live = false) {
    let result;
    try {
        const deleteFavoriteTask = new DeleteFavoriteTask(groupId, live);
        result = await RequestManager.addRequest(deleteFavoriteTask);
        return Promise.resolve(result);
    } catch (err) {
        console.error('[deleteFavorite] Error calling DeleteFavoriteTask ', err);
        return Promise.resolve(err);
    }
}

export async function blockChannel(groupId) {
    let result;
    try {
        const addBlockedChannelsTask = new AddBlockedChannelsTask(groupId);
        result = await RequestManager.addRequest(addBlockedChannelsTask);
        return Promise.resolve(result);
    } catch (err) {
        console.error('[blockChannel] Error calling addBlockedChannelsTask ', err);
        return Promise.resolve(err);
    }
}

export async function unblockChannel(groupId) {
    let result;
    try {
        const deleteBlockedChannelsTask = new DeleteBlockedChannelsTask(groupId);
        result = await RequestManager.addRequest(deleteBlockedChannelsTask);
        return Promise.resolve(result);
    } catch (err) {
        console.error('[unblockedChannel] Error calling DeleteBlockedChannelsTask ', err);
        return Promise.resolve(err);
    }
}

export async function checkBlockedChannel(groupId) {
    let result;
    try {
        const checkBlockedChannelsTask = new CheckBlockedChannelsTask(groupId);
        result = await RequestManager.addRequest(checkBlockedChannelsTask);
        return Promise.resolve(result);
    } catch (err) {
        console.error('[checkBlockedChannel] Error calling CheckBlockedChannelsTask ', err);
        return Promise.resolve(err);
    }
}

export async function createReminder(eventId, expDate, typeEvent, channelId) {
    let result;
    try {
        const reminderCreateTask = new ReminderCreateTask(eventId, expDate, typeEvent, channelId);
        result = await RequestManager.addRequest(reminderCreateTask);
        return Promise.resolve(result);
    } catch (err) {
        console.error('[createReminder] Error calling ReminderCreateTask ', err);
        return Promise.resolve(err);
    }
}

export async function deleteReminder(reminderId) {
    let result;
    try {
        const reminderDeleteTask = new ReminderDeleteTask(reminderId);
        result = await RequestManager.addRequest(reminderDeleteTask);
        return Promise.resolve(result);
    } catch (err) {
        console.error('[deleteReminder] Error calling ReminderDeleteTask ', err);
        return Promise.resolve(err);
    }
}

export async function getReminders() {
    let result;
    try {
        const reminderListTask = new ReminderListTask();
        result = await RequestManager.addRequest(reminderListTask);
        return Promise.resolve(result);
    } catch (err) {
        console.error('[getReminders] Error calling ReminderListTask ', err);
        return Promise.resolve(err);
    }
}

//esta funcion debe ser la unica a ocupar para checar el status del pin parental
export async function getPinStatus() {
    let result;
    try {
        const pinStatusWithTimerValidationTask = new PinStatusWithTimerValidationTask();
        result = await RequestManager.addRequest(pinStatusWithTimerValidationTask);
        if (result.data) result.response = result.data;
        if (result) {
            let blockedChannels = []
            AAF.Pin.handleDataPinCodesSuccess(result, blockedChannels)
        } else {
            let blockedChannels = []
            AAF.Pin.handleDataPinCodesError(blockedChannels)
        }
        return Promise.resolve(result);
    } catch (err) {
        let blockedChannels = []
        AAF.Pin.handleDataPinCodesError(blockedChannels)
        console.error('[getPinStatus] Error calling getPinStatus ', err);
        return Promise.resolve(err);
    }
}

export async function getPureEpg(params) {
    let result;
    try {
        const pureEpgTask = new PureEpgTask(params);
        result = await RequestManager.addRequest(pureEpgTask);
        if (result && result.response) return Promise.resolve(result.response);
        else return Promise.resolve(null);
    } catch (err) {
        console.error('[getPureEpg] Error calling getPureEpg ', err);
        return Promise.resolve({});
    }
}

export async function getFilters(params) {
    let result;
    try {
        const filtersTask = new FiltersTask(params);
        result = await RequestManager.addRequest(filtersTask);
        if (result && result.response) return Promise.resolve(result.response);
        else return Promise.resolve(null);
    } catch (err) {
        console.error('[getPureEpg] Error calling getPureEpg ', err);
        return Promise.resolve({});
    }
}

export async function getLevel(url, params) {
    let result;
    try {
        const levelTask = new LevelRibbonTask(url, params);
        result = await RequestManager.addRequest(levelTask);
        if (result && result.response) return Promise.resolve(result.response);
        else return Promise.resolve(null);
    } catch (err) {
        console.error('[getPureEpg] Error calling getPureEpg ', err);
        return Promise.resolve({});
    }
}

export async function getLevelGeneric(params) {
    let result;
    try {
        const levelTask = new LevelGenericTask(params);
        result = await RequestManager.addRequest(levelTask);
        if (result && result.response) return Promise.resolve(result.response);
        else return Promise.resolve(null);
    } catch (err) {
        console.error('[getLevelGeneric] Error calling LevelGenericTask ', err);
        return Promise.resolve({});
    }
}

export async function getSimpleGet(url, params) {
    let result;
    try {

        const simpleGetRequestTask = new SimpleGetRequestTask(url, params);

        result = await RequestManager.addRequest(simpleGetRequestTask);
        if (result && result.response) return Promise.resolve(result.response);
        else return Promise.resolve(null);
    } catch (err) {
        console.error('[getSimpleGet] Error calling getSimpleGet ', err);
        return Promise.resolve({});
    }
}



function getCmAccessToken() {
    const _cm = store.getState().user;
    const cm_access_token = _cm.musicUser && _cm.musicUser.cm_access_token ? _cm.musicUser.cm_access_token : '';
    return cm_access_token;
}

export async function getPlaylistDetail(params) {
    let result;
    try {
        const headers = {};
        params.cm_access_token = getCmAccessToken();
        const playlistDetailTask = new PlaylistDetailTask(params, headers);
        result = await RequestManager.addRequest(playlistDetailTask);
        if (result && result.response) return Promise.resolve(result.response);
        else if (result && result.error) {
            return Promise.resolve(result.error);
        }
        else return Promise.resolve(null);
    } catch (err) {
        console.error('[getPlaylistDetail] Error calling /cms/playlist/ ', err);
        return Promise.resolve({});
    }
}

export async function getAlbumDetail(params) {
    let result;
    try {
        const headers = {};
        params.cm_access_token = getCmAccessToken();
        const albumDetailTask = new AlbumDetailTask(params, headers);
        result = await RequestManager.addRequest(albumDetailTask);
        if (result && result.response) return Promise.resolve(result.response);
        else return Promise.resolve(null);
    } catch (err) {
        console.error('[getAlbumDetail] Error calling /cms/album/ ', err);
        return Promise.resolve({});
    }
}

export async function getArtistDetail(params) {
    let result;
    try {
        const headers = {};
        params.cm_access_token = getCmAccessToken();
        const albumDetailTask = new ArtistDetailTask(params, headers);
        result = await RequestManager.addRequest(albumDetailTask);
        if (result && result.response) return Promise.resolve(result.response);
        else return Promise.resolve(null);
    } catch (err) {
        console.error('[getAlbumDetail] Error calling /cms/artist/artistSong ', err);
        return Promise.resolve({});
    }
}

export async function getArtistAlbums(params) {
    let result;
    try {
        const headers = {};
        params.cm_access_token = getCmAccessToken();

        const artistAlbumsTask = new ArtistAlbumsTask(params, headers);
        result = await RequestManager.addRequest(artistAlbumsTask);
        if (result && result.response) return Promise.resolve(result.response);
        else return Promise.resolve(null);
    } catch (err) {
        console.error('[getArtistAlbums] Error calling /artist/artistAlbums/ ', err);
        return Promise.resolve({});
    }
}

export async function getArtistSimilar(params) {
    let result;
    try {
        const headers = {};
        params.cm_access_token = getCmAccessToken();
        const artistSimilarTask = new ArtistSimilarTask(params, headers);
        result = await RequestManager.addRequest(artistSimilarTask);
        if (result && result.response) return Promise.resolve(result.response);
        else return Promise.resolve(null);
    } catch (err) {
        console.error('[getArtistSimilar] Error calling /artist/artistSimilar/ ', err);
        return Promise.resolve({});
    }
}

export async function getArtistRadiosLive(params) {
    let result;
    try {
        const headers = {};
        params.cm_access_token = getCmAccessToken();
        const artistRadiosLiveTask = new ArtistRadiosLiveTask(params, headers);
        result = await RequestManager.addRequest(artistRadiosLiveTask);
        if (result && result.response) return Promise.resolve(result.response);
        else return Promise.resolve(null);
    } catch (err) {
        console.error('[getArtistRadiosLive] Error calling /artist/artistSimilar/ ', err);
        return Promise.resolve({});
    }
}

export async function toggleFollow(path, params) {
    let result;
    try {
        const headers = {};
        params.cm_access_token = getCmAccessToken();
        const toggleFollowTask = new ToggleFollowTask(path, params, headers);
        result = await RequestManager.addRequest(toggleFollowTask);
        if (result) return Promise.resolve(result);
        else return Promise.resolve(false);
    } catch (err) {
        console.error('[toggleFollow] Error calling toggleFollow', err);
        return Promise.resolve(false);
    }
}

export async function getGenreRadios(params) {
    let result;
    try {
        const headers = {};
        params.cm_access_token = getCmAccessToken();
        const genreRadiosTask = new GenreRadiosTask(params, headers);
        result = await RequestManager.addRequest(genreRadiosTask);
        if (result && result.response) return Promise.resolve(result.response);
        else return Promise.resolve(null);
    } catch (err) {
        console.error('[getArtistRadiosLive] Error calling /genreRadios ', err);
        return Promise.resolve({});
    }
}

export async function simpleCMMRequest(url, headers, middlewareVersion = '1.0.0') {
    let result;
    try {
        const cm_access_token = getCmAccessToken();
        url = `${url}&version=${middlewareVersion}&cm_access_token=${cm_access_token}`;
        const simpleCMMTask = new SimpleCMMTask(url, headers, middlewareVersion);

        result = await RequestManager.addRequest(simpleCMMTask);
        if (result) return Promise.resolve(result.success);
        else return Promise.resolve(false);
    } catch (err) {
        console.error(`[simpleCMMRequest] Error calling ${url}: ${err}`);
        return Promise.resolve(false);
    }
}

export async function getUserInfo(email) {
    let result;
    try {
        const getUser = new GetUserInfoTask(email);
        result = await RequestManager.addRequest(getUser);
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function modifyUser(params, method) {
    let result;
    try {
        const modifyUserTask = new ModifyUserTask(params, method);
        result = await RequestManager.addRequest(modifyUserTask);
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function removeLiveChannel(group_id) {
    let result;
    try {
        const removeLiveChannelTask = new RemoveLiveChannelTask('/services/user/removelivechannel', group_id);
        result = await RequestManager.addRequest(removeLiveChannelTask);

        if (result.errors || result.status == 1 || result.response === 'error') {
            return new Promise((reject) => {
                reject(result);
            });
        }
        else {
            return new Promise((resolve) => {
                resolve(result);
            });
        }
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function removeLastSeen(group_id) {
    let result;
    try {
        const removeLastSeenTask = new RemoveLastSeenTask('/services/user/v1/seendel', group_id);
        result = await RequestManager.addRequest(removeLastSeenTask);

        if (result.errors || result.status == 1 || result.response === 'error') {
            return new Promise((reject) => {
                reject(result);
            });
        }
        else {
            return new Promise((resolve) => {
                resolve(result);
            });
        }
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function removeRecordings(recording_id) {
    let result;
    try {
        const removeRecordingsTask = new RemoveRecordingsTask('/services/recordings/delete', recording_id);
        result = await RequestManager.addRequest(removeRecordingsTask);

        if (result.errors || result.status == 1 || result.response === 'error') {
            return new Promise((reject) => {
                reject(result);
            });
        }
        else {
            return new Promise((resolve) => {
                resolve(result);
            });
        }
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function changePaymentInfo(postParams) {
    let result;
    try {
        const changePayment = new ChangePaymentInfoTask(postParams);
        result = await RequestManager.addRequest(changePayment);
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}

export async function suspendedAccount(params, version) {
    let result;
    try {
        const userSuspended = new UserSuspendedTask(params, version);
        result = await RequestManager.addRequest(userSuspended);
        return new Promise((resolve, reject) => {
            resolve(result);
        });
    } catch (err) {
        console.error('[suspendedAccount] err', err)
        return new Promise((resolve, reject) => {
            reject(err);
        });
    }
}



// WEBPACK FOOTER //
// ./src/requests/loader.js